import { render, staticRenderFns } from "./weeksView.vue?vue&type=template&id=2d4ff2e6&scoped=true&"
import script from "./weeksView.vue?vue&type=script&lang=js&"
export * from "./weeksView.vue?vue&type=script&lang=js&"
import style0 from "./weeksView.vue?vue&type=style&index=0&id=2d4ff2e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4ff2e6",
  null
  
)

export default component.exports